'use client';

import type { ReactNode } from 'react';
import { ToastProvider } from '~/components/Toast';
import { CurrencyState } from '~/contexts/Currencies';
import type { CurrencyName } from '~/utils/currencyHelpers';

interface SharedProvidersProps {
  children: ReactNode;
  initialCurrency?: CurrencyName;
}

export function SharedProviders({ children, initialCurrency }: Readonly<SharedProvidersProps>) {
  return (
    <CurrencyState initialCurrency={initialCurrency}>
      <ToastProvider>{children}</ToastProvider>
    </CurrencyState>
  );
}
